module.exports = __webpack_public_path__ + "img/d92a6aa1f5f8457f0061acae355c7c8d.svg";